import React, { useEffect } from "react"

export type Props = {
    visible: boolean,
}

export const ModalLoading = React.memo(({ visible }: Props) => {

    useEffect(() => {

        if (visible) {

            let modal = document.getElementById('modal_loading')
            let modalContent = document.getElementById('modal_content_loading')

            if (modal) {
                modal.style.visibility = 'visible'

                if (modalContent) {
                    modalContent.classList.remove('mt-[-500px]')
                    modalContent.classList.add('mt-2')
                }
            }

        } else {

            let modal = document.getElementById('modal_loading')
            let modalContent = document.getElementById('modal_content_loading')

            if (modal) {
                modal.style.visibility = 'hidden'

                if (modalContent) {
                    modalContent.classList.add('mt-[-500px]')
                    modalContent.classList.remove('mt-2')
                }
            }
        }

    }, [visible])

    // ------------------------------------------------------------------------- FUNÇÕES DE IMPRESSÃO ----------------------------------------------------------------------

    return (

        <div id="modal_loading" style={{ visibility: "hidden", backgroundColor: 'rgba(0,0,0, 0.6)' }} className={`flex justify-center items-center fixed left-0 right-0 top-0 bottom-0 z-40`}>

            <div id="modal_content_loading" className={`relative flex flex-col w-[90%] xl:w-[70%] h-[500px] rounded-lg mt-[-500px] justify-center items-center`}>

                <div className={`absolute top-[0px] left-[0px] right-[0px] bottom-[0px] w-full flex justify-center items-center`}>

                    <div className={`h-8 w-8 mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                        <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                    </div>

                </div>

            </div>

        </div>

    )
})